import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FiX } from "react-icons/fi";
import { toast } from "react-hot-toast";
import {
  useGetSingleAppraisalQuery,
  useUpdateAppraisalPeriodMutation
} from "../../../../../api/hrApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import {
  CheckBox,
  FormSelect,
  FormTemplate,
} from "../../../../Components/Forms/InputTemplate";

const EditAppraisalPeriodModal = ({
  setIsOpen,
  isOpen,
  isLoading,
  onValidate,
  id,
}) => {
  const { data } = useGetSingleAppraisalQuery(id);
  const formMethods = useForm({
    defaultValues: {
      Year: "",
      currentYear: "",
      endMonth: "",
      startMonth: "",
    },
    mode: "all",
  });
  const {
    handleSubmit,
    formState: { isValid },
    reset,
  } = formMethods;
  useEffect(() => {
    if (data?.responseObject) {
      reset({
        Year: data?.responseObject?.year?.toString() || "",
        currentYear: data?.responseObject?.currentYear || false,
        endMonth:
          data?.responseObject?.endMonth?.toString().padStart(2, "0") || "",
        startMonth:
          data?.responseObject?.startMonth?.toString().padStart(2, "0") || "",
      });
    }
  }, [data, reset]);
  const [onUpdate, { isLoading: isCreating }] =
    useUpdateAppraisalPeriodMutation();
  const submit = async (data) => {
    const payload = {
      id,
      Year: data.Year,
      currentYear: data.currentYear,
      endMonth: parseInt(data.endMonth),
      startMonth: parseInt(data.startMonth),
    };
    try {
      const response = await onUpdate(payload).unwrap();
      if (response?.successful) {
        toast.success(response?.statusMessage);
        onValidate();
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.data?.statusMessage);
    }
  };

  const currentYear = new Date().getFullYear() + 100;
  const dates = Array.from({ length: currentYear - 1999 + 1 }, (_, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString(),
  }));

  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h4 className="text-[25px] font-[500]">Set Up </h4>
          <h1 className="text-[28px] font-[800]">Appraisal Period</h1>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        {isLoading && <small>Loading...</small>}
        <div>
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              <FormSelect
                title={"Year"}
                camelCase={"Year"}
                placeholder={"select"}
                array={dates.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
                defaultValue={0}
              />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <FormSelect
                  title={"Start Month"}
                  camelCase={"startMonth"}
                  placeholder={"select"}
                  array={months.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                  defaultValue={0}
                />
                <FormSelect
                  title={"End Month"}
                  camelCase={"endMonth"}
                  placeholder={"select"}
                  array={months.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                  defaultValue={0}
                />
              </div>
              <div className="flex items-center gap-4">
                <CheckBox camelCase={"currentYear"} />
                <p>Current Year</p>
              </div>
              <div
                style={{ marginTop: "1rem" }}
                className={DashboardStyle.button_cage}
              >
                <ActionButtons
                  isLoading={isLoading}
                  disabled={!isValid || isCreating}
                  width={"auto"}
                  type={"submit"}
                  className={DashboardStyle?.button_cage_weight}
                  bg="var(--primary-color)"
                >
                  {isCreating ? "Updating..." : "Update Appraisal Period"}
                </ActionButtons>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default EditAppraisalPeriodModal;
